<div class="wrapper">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [size]="size"
        [model]="filteredTableModel"
        [menuItems]="menuItems"
        [contextualMenu]="!readOnly"
        [creationIcon]="true"
        [readOnly]="readOnly"
        [sortEnabled]="true"
        (menuClicked)="onAction($event)"
        (rowClicked)="onSelection($event)"
        (createIconClicked)="onCreation()"
        (itemsSorted)="onItemsSorted($event)"></app-advanced-gridview>
</div>
